import type { ComponentType } from "react";
import { Calendar, Clock10, Globe, Hash, Sigma, Type } from "lucide-react";
import { rawColors } from "../../design-system/tokens/colors";

/**
 * Every field-type glyph the app shows next to a column or data-model field.
 * Kinds follow the API's `dataType` (Data models panel contract) so a field
 * renders its icon without a translation step.
 */
export type FieldTypeIconKind =
  | "date"
  | "time"
  | "text"
  | "geo"
  | "number"
  | "calculated";

export interface FieldTypeIconConfig {
  Icon: ComponentType<{ size?: number | string }>;
  color: string;
  /** Human name of the type — the type chip on the field-detail card ("Date"). */
  label: string;
}

/**
 * Figma bakes a stroke colour into each type icon rather than binding a
 * variable (Data models 6433:559545, story filter 6583:205467). Each hex is an
 * exact match for an existing accent token, so there is no token gap. Swap a
 * glyph or colour here and every consumer follows.
 */
export const fieldTypeIcons: Record<FieldTypeIconKind, FieldTypeIconConfig> = {
  date: { Icon: Calendar, color: rawColors.accent.dataModelRed, label: "Date" },
  time: { Icon: Clock10, color: rawColors.accent.dataModelRed, label: "Time" },
  text: { Icon: Type, color: rawColors.accent.ontologyGreen, label: "Text" },
  geo: { Icon: Globe, color: rawColors.accent.dataStoryPurple, label: "Geographic" },
  number: { Icon: Hash, color: rawColors.accent.metricBlue, label: "Number" },
  calculated: { Icon: Sigma, color: rawColors.accent.pink, label: "Calculated" },
};
